import React, { Component } from 'react';
import Select from "react-select";

class CustomSelect extends Component {
  state = {
    isMenuOpen: false
  };

  sortItems = (items) => {
    if (!items) return;
    
    items.sort((elemA, elemB) => !elemA.prevent_sorting && !elemB.prevent_sorting && elemA.label.localeCompare(elemB.label));

    return items;
  };

  onMenuOpen = () => {
    this.setState({
      isMenuOpen: true
    });
  };

  onMenuClose = () => {
    this.setState({
      isMenuOpen: false
    });
  };

  render() {
    const { isMenuOpen } = this.state;
    const { id, value, required, clearable, onChange, options, className,
      disabled, enableSort, label, isSearchable, placeholder } = this.props;

    return (
      <>
        {label?.length && (
          <label className='floating-select-label' htmlFor={ id }>
            {label}
          </label>
        )}
        <Select
          inputId={ id }
          name={ id }
          className={ className }
          value={ (options && options.length && options.find(option => option.value.toString() === value.toString())) || "" }
          isDisabled={ disabled }
          required={ required }
          isClearable={ clearable }
          isSearchable={ isSearchable }
          placeholder={ placeholder }
          onMenuOpen={ () => this.onMenuOpen() }
          onMenuClose={ () => this.onMenuClose() }
          onChange={ (event) => onChange(event) }
          styles={ {
            control: (baseStyles, state) => ({
              ...baseStyles,
              minHeight: "40px",
              cursor: "pointer",
              borderWidth: '1px',
              borderColor: 'rgb(181, 181, 181) !important',
              borderStyle: 'solid',
              borderRadius: '8px',
              backgroundColor: '#ffffff',
              boxShadow: 'none',
              fontSize: '12px',
              ...(state.isDisabled && {
                backgroundColor: "#F9F9F9",
                borderColor: "#CCCCCC"
              }),
            }),
            singleValue: (baseStyles, state) => ({
              ...baseStyles,
              color: '#2d2d2d',
              fontSize: '12px',
              ...(state.isDisabled && { color: "#555555" })
            }),
            placeholder: (baseStyles, state) => ({
              ...baseStyles,
              color: '#2d2d2d',
              fontSize: '12px',
              fontFamily: "'Lufga Regular', sans-serif",
              ...(state.isDisabled && { color: "#555" })
            }),
            menu: (baseStyles) => ({
              ...baseStyles,
              margin: 0,
              zIndex: 4
            }),
            option: (baseStyles) => ({
              ...baseStyles,
              cursor: "pointer",
              fontSize: '12px'
            }),
            indicatorSeparator: (baseStyles) => ({
              ...baseStyles,
              display: 'none'
            }),
            dropdownIndicator: (baseStyles) => ({
              ...baseStyles,
              '& svg': {
                fill: '#000000',
                transition: 'all 0.3s ease',
                ...(isMenuOpen && { transform: "rotate(180deg)" })
              }
            }),
            Svg: (baseStyles) => ({
              ...baseStyles,
              display: 'none'
            })
          } }
          options={ enableSort === false ? options :  this.sortItems(options) }
        />
      </>
    );
  }
}

export default CustomSelect;